import { mtFetch, type FetchResult } from "./mtFetch";

export interface BackupItem {
  readonly key: string;
  readonly filename: string;
  readonly kind: string;
  readonly source: string;
  readonly size: number;
  /** Момент СЪЁМКИ дампа (из имени файла). Для перелитых между хранилищами
   *  объектов last_modified — дата копирования, а не бэкапа. */
  readonly taken_at: string | null;
  readonly last_modified: string | null;
}

/** Свежесть последнего регулярного бэкапа этого инстанса. */
export interface BackupHealth {
  readonly configured: boolean;
  readonly healthy: boolean;
  readonly age_hours?: number | null;
  readonly latest_key?: string | null;
  readonly taken_at?: string | null;
  readonly max_age_hours?: number;
  readonly reason?: string;
}

export interface BackupList {
  readonly schema_version: string;
  readonly configured: boolean;
  readonly source: string;
  readonly backups: readonly BackupItem[];
  readonly health?: BackupHealth;
}

export interface BackupCreated {
  readonly schema_version: string;
  readonly backup: {
    readonly key: string;
    readonly filename: string;
    readonly kind: string;
    readonly source: string;
    readonly size: number;
    readonly created_at: string;
  };
}

export interface BackupDownload {
  readonly schema_version: string;
  readonly url: string;
}

export function listBackups(): Promise<FetchResult<BackupList>> {
  return mtFetch<BackupList>("/admin/backups-list");
}

export function createBackup(): Promise<FetchResult<BackupCreated>> {
  return mtFetch<BackupCreated>("/admin/backups-create", { method: "POST" });
}

export function getBackupDownloadUrl(
  key: string,
): Promise<FetchResult<BackupDownload>> {
  return mtFetch<BackupDownload>("/admin/backups-download", { query: { key } });
}
